import { AssistanceRequestActions, EAssistanceRequestActions } from "@edp-store/actions/assistence-request.actions";
import { IAssistanceRequestState, initialAssistanceRequestState } from "@edp-store/state/assistance-request.state";

export function assistanceRequestReducers(
    state = initialAssistanceRequestState,
    action: AssistanceRequestActions
): IAssistanceRequestState {
    switch (action.type) {
        case EAssistanceRequestActions.SetSymptoms: {
            return {
                ...state,
                assistanceRequest: action.assistanceRequest,
            };
        }
        case EAssistanceRequestActions.SetEquipments: {
            return {
                ...state,
                equipments: action.equipments,
            };
        }
        default: {
            return state;
        }
    }
}
